import { IIconProps } from './icon';

interface IIconStarProps extends IIconProps {
  isFavorited?: boolean;
}

export const IconStar = ({
  style = {},
  cy,
  isFavorited = false,
}: IIconStarProps) => {
  return (
    <>
      {isFavorited ? (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={style}
          data-cy={`IconStar${cy}`}
        >
          <path
            d="M6.99998 10.8465L11.12 13.3332L10.0266 8.6465L13.6666 5.49317L8.87331 5.0865L6.99998 0.666504L5.12665 5.0865L0.333313 5.49317L3.97331 8.6465L2.87998 13.3332L6.99998 10.8465Z"
            fill="#FFF844"
          />
        </svg>
      ) : (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={style}
          data-cy={`IconStar${cy}`}
        >
          <path
            d="M13.6666 5.49317L8.87331 5.07984L6.99998 0.666504L5.12665 5.0865L0.333313 5.49317L3.97331 8.6465L2.87998 13.3332L6.99998 10.8465L11.12 13.3332L10.0333 8.6465L13.6666 5.49317ZM6.99998 9.59984L4.49331 11.1132L5.15998 8.25984L2.94665 6.33984L5.86665 6.0865L6.99998 3.39984L8.13998 6.09317L11.06 6.3465L8.84665 8.2665L9.51331 11.1198L6.99998 9.59984Z"
            fill="#6F7171"
          />
        </svg>
      )}
    </>
  );
};
